<template>
  <div
    class="mx-auto flex min-h-[calc(100dvh-64px)] max-w-3xl flex-col pb-2 md:h-[calc(100dvh-80px)] md:min-h-auto md:pb-10"
  >
    <div class="grow flex flex-col justify-center items-center">
      <h1 class="text-center text-title-large md:text-display-large lg:text-display-large">
        Herzlichen Dank für Dein Feedback!
      </h1>
    </div>
  </div>
</template>

<script lang="ts" setup></script>
